import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import get from 'lodash.get'
import set from 'lodash.set'
import moment from 'moment'
import {
  Button,
  message,
  PageHeader,
  Space,
} from 'antd'
import { Form, Formik } from 'formik'
import {
  getOrderDetails,
  getOrdersMine,
  updateOrder,
} from '../../network/Orders'
import {
  get3Dlook,
  getClientDetails,
  updateClient,
} from '../../network/Clients'
import { formOptions } from '../../forms/blocks'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import { getProductPrices } from '../../network/ProductPrices'
import { getFromKey, getFixedDesignCategory } from './utils/orderHelpers'
import Step1 from './steps/Step1'
import Step2 from './steps/Step2'
import Step3 from './steps/Step3'
import Step4 from './steps/Step4'
import Step5 from './steps/Step5'

const ModifyOrder = ({ history }) => {
  const [canDirectPayment, setCanDirectPayment] = useState(true)
  let { orderId } = useParams()
  const myRef = useRef(null)
  const [step, setStep] = useState(1)
  const [innerStep, setInnerStep] = useState(0)
  const [afterStep3, setAfterStep3] = useState(false)
  const queryClient = useQueryClient()
  const { storeId } = useParams()

  useEffect(() => {
    const fetchShirtPricing = async () => {
      try {
        const data = await getProductPrices()
        const shirtPricing =
          data.list.products?.find((p) => p.key === 'shirt')?.pricing || []
        window.shirtPricing = shirtPricing
      } catch (error) {
        console.error('Failed to fetch shirt pricing:', error)
      }
    }
    fetchShirtPricing()
  }, [])

  const orderDetails = useQuery(
    [
      'getOrderDetails',
      {
        id: orderId,
        onSuccess: (data) => {
          if (get(data, 'validated', false)) {
            history.push(`/orders/${orderId}`)
          }
        },
      },
    ],
    getOrderDetails,
    {
      refetchOnWindowFocus: false,
    }
  )

  const clientDetails = useQuery(
    [
      'getClientDetails',
      {
        id: orderDetails.data?.customer,
      },
    ],
    getClientDetails,
    {
      disabled: !orderDetails.data?.customer,
      refetchOnWindowFocus: false,
    }
  )

  const client3DLDetails = useQuery(
    [
      '3DLook',
      {
        id: orderDetails.data?.customer,
      },
    ],
    () => get3Dlook(orderDetails.data?.customer),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      disabled: !orderDetails.data?.customer,
    }
  )

  const clientOrders = useQuery(
    [
      'getOrdersMine',
      {
        sort: ['createdAt', 'ASC'],
        filter: {
          customer: orderDetails.data?.customer,
        },
      },
    ],
    getOrdersMine,
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  )

  const udpateOrder = useMutation((e) => updateOrder(e, orderId), {
    onSuccess: () => {
      history.push('/orders')
      window.location.reload()
    },
    onError: (error) => {
      message.error(
        error.response?.data?.debugLog?.message ||
          error.response?.data?.message ||
          'An error occurs'
      )
    },
  })

  const saveUser = useMutation(
    (val) => updateClient(val, orderDetails.data?.customer)
    // {
    //   onSuccess: message.success('User info saved'),
    // }
  )

  const handleBack = () => {
    if (step === 1) {
      history.push(`/orders/${orderId}`)
    } else {
      myRef.current?.scrollIntoView()
      setStep(step - 1)
      // if (step === 4) setAfterStep3(false)
    }
  }

  const handleNext = () => {
    if (step === 5) {
      history.push('/orders')
    } else {
      myRef.current?.scrollIntoView()
      setStep(step + 1)
      // if (step === 3) setAfterStep3(true)
    }
  }

  const saveUserInfos = async (values) => {
    let clientInfos = get(clientDetails, 'data', {})

    let bodyMeasurements = undefined
    if (get(clientInfos, 'bodyMeasurements.measurementSource', '') === 'af') {
      bodyMeasurements = {
        ...get(clientInfos, 'bodyMeasurements', {}),
        ...get(values, 'bodyMeasures', {}),
      }
    }

    // Get bodyPictures from values, fallback to clientInfos if not present
    const bodyPictures = get(
      values,
      'bodyPictures',
      get(clientInfos, 'bodyPictures', [])
    )

    const newInfos = {
      ...clientInfos,
      complexion: {
        ...get(clientInfos, 'complexion', {}),
        ...get(values, 'complexion', {}),
      },
      bodyPictures: bodyPictures,
      bodyMeasurements,
      foot: { ...get(clientInfos, 'foot', {}), ...get(values, 'foot', {}) },
      clientTags: get(values, 'clientTags', get(clientInfos, 'clientTags', [])),

      birthDate: get(values, 'birthDate', undefined),
      country: get(values, 'country', undefined),
      city: get(values, 'city', undefined),
      nationality: get(values, 'nationality', undefined),
    }

    saveUser.mutate(newInfos)
  }

  const saveBeforeSwitch = (values) => {
    let clientInfos = get(clientDetails, 'data', {})

    // Get bodyPictures from values, fallback to clientInfos if not present
    const bodyPictures = get(
      values,
      'bodyPictures',
      get(clientInfos, 'bodyPictures', [])
    )

    const newInfos = {
      ...clientInfos,
      complexion: {
        ...get(clientInfos, 'complexion', {}),
        ...get(values, 'complexion', {}),
      },
      bodyPictures: bodyPictures,
      bodyMeasurements: get(values, 'bodyMeasures', {}),
      foot: { ...get(clientInfos, 'foot', {}), ...get(values, 'foot', {}) },
      clientTags: get(values, 'clientTags', get(clientInfos, 'clientTags', [])),

      birthDate: get(values, 'birthDate', undefined),
      country: get(values, 'country', undefined),
      city: get(values, 'city', undefined),
      nationality: get(values, 'nationality', undefined),
    }

    saveUser.mutate(newInfos)

    queryClient.setQueryData(
      [
        'getClientDetails',
        {
          id: orderDetails.data?.customer,
        },
      ],
      (oldData) => ({ ...oldData, ...newInfos })
    )
  }

  return (
    <div className="" ref={myRef}>
      <PageHeader
        className="site-page-header"
        title="Modify order"
        onBack={() => history.push(`/orders/${orderId}/store/${storeId}`)}
        style={{ backgroundColor: '#fff' }}
      />
      {orderDetails.isError || clientDetails.isError ? (
        <Error retry={() => orderDetails.refetch()} />
      ) : orderDetails.isLoading || clientDetails.isLoading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={{
            ...get(orderDetails, 'data', {}),
            comment: get(orderDetails, 'data.comment', ''),
            birthDate: clientDetails?.data?.birthDate
              ? moment(clientDetails?.data?.birthDate)
              : undefined,
            country: get(clientDetails, 'data.country', undefined),
            city: get(clientDetails, 'data.city', undefined),
            nationality: get(clientDetails, 'data.nationality', undefined),
            bodyPictures: get(clientDetails, 'data.bodyPictures', []),
            complexion: {
              ...get(clientDetails, 'data.complexion', {}),
            },
            bodyMeasures: {
              ...get(clientDetails, 'data.bodyMeasurements', {}),
            },
            foot: { ...get(clientDetails, 'data.foot', {}) },
            clientTags: get(clientDetails, 'data.clientTags', []),
          }}
          validate={(values) => {
            const errors = {}
            if (step === 1) {
              if (!values.orderProducts?.length) {
                errors.orderProducts = 'At least a product is required'
              } else {
                for (let i = 0; i < values.orderProducts.length; i++) {
                  const path = ['orderProducts', i]
                  const currentProduct = values.orderProducts[i]
                  if (
                    currentProduct.orderProductType === 'fixed_design'
                  ) {
                    // Validate fixed_design products
                    if (!get(currentProduct, `orderFixedDesign.price`, null)) {
                      set(
                        errors,
                        `orderProducts.${i}.orderFixedDesign.price`,
                        'Required'
                      )
                    }
                  } else if (
                    currentProduct.orderProductType !== 'collection' &&
                    currentProduct.orderProductType !== 'adjustment'
                  ) {
                    if (!get(currentProduct, `orderCustom.price`, null)) {
                      set(
                        errors,
                        `orderProducts.${i}.orderCustom.price`,
                        'Required'
                      )
                    }

                    formOptions[getFromKey(currentProduct)]?.forms?.forEach(
                      (form) =>
                        form.form.forEach((prodForm) =>
                          prodForm.sections.forEach((section) => {
                            if (section.canAdd) {
                              section.fields.forEach((field) => {
                                const type = getFromKey(currentProduct)
                                if (type === 'shirt') {
                                  const extraShirts =
                                    currentProduct.orderCustom.orderCustomShirt
                                      .extraShirts
                                  if (extraShirts) {
                                    //validation
                                    extraShirts.forEach((item, index) => {
                                      const fieldValue = get(
                                        values,
                                        [
                                          ...path,
                                          form.key,
                                          ...prodForm.key,
                                          ...section.key,
                                          index,
                                          ...field.key,
                                        ].join('.'),
                                        ''
                                      )

                                      const name =
                                        [
                                          ...path,
                                          form.key,
                                          ...prodForm.key,
                                          ...section.key,
                                          index,
                                        ].join('.') + '.'
                                      const fieldIsRequired =
                                        field.isConditionalRequired
                                          ? field.isConditionalRequired(
                                              values,
                                              name
                                            )
                                          : !!field.isRequired
                                      const valueIsOk =
                                        !!fieldValue || fieldValue === 0
                                      const valueIsDisplay =
                                        !field.isHiding ||
                                        (field.isHiding &&
                                          !field.isHiding(values, name))

                                      if (
                                        fieldIsRequired &&
                                        !valueIsOk &&
                                        valueIsDisplay
                                      ) {
                                        set(
                                          errors,
                                          [
                                            ...path,
                                            form.key,
                                            ...prodForm.key,
                                            ...section.key,
                                            index,
                                            ...field.key,
                                          ].join('.'),
                                          'This field is required'
                                        )
                                      }
                                    })
                                  }
                                }
                              })
                            } else {
                              section.fields.forEach((field) => {
                                const fieldValue = get(
                                  values,
                                  [
                                    ...path,
                                    form.key,
                                    ...prodForm.key,
                                    ...field.key,
                                  ].join('.'),
                                  ''
                                )
                                const name =
                                  [...path, form.key, ...prodForm.key].join(
                                    '.'
                                  ) + '.'
                                const fieldIsRequired =
                                  field.isConditionalRequired
                                    ? field.isConditionalRequired(values, name)
                                    : !!field.isRequired
                                const valueIsOk =
                                  !!fieldValue || fieldValue === 0
                                const valueIsDisplay =
                                  !field.isHiding ||
                                  (field.isHiding &&
                                    !field.isHiding(values, name))
                                if (
                                  fieldIsRequired &&
                                  !valueIsOk &&
                                  valueIsDisplay
                                ) {
                                  set(
                                    errors,
                                    [
                                      ...path,
                                      form.key,
                                      ...prodForm.key,
                                      ...field.key,
                                    ].join('.'),
                                    'This field is required'
                                  )
                                }
                              })
                            }
                          })
                        )
                    )
                  } else if (currentProduct.orderProductType === 'adjustment') {
                    const adjustmentProduct = get(
                      values,
                      `orderProducts.${i}.orderAdjustment`,
                      []
                    )
                    if (!adjustmentProduct.type) {
                      set(
                        errors,
                        `orderProducts.${i}.orderAdjustment.type`,
                        'Select a product type'
                      )
                    } else {
                      formOptions[adjustmentProduct.type].forms.forEach(
                        (form) =>
                          form.form.forEach((prodForm) =>
                            prodForm.sections.forEach((section) =>
                              section.fields.forEach((field) => {
                                const fieldValue = get(
                                  values,
                                  [
                                    ...path,
                                    form.key.replace(
                                      'orderCustom.',
                                      'orderAdjustment.'
                                    ),
                                    ...prodForm.key,
                                    ...field.key,
                                  ].join('.'),
                                  ''
                                )

                                const name =
                                  [
                                    ...path,
                                    form.key.replace(
                                      'orderCustom.',
                                      'orderAdjustment.'
                                    ),
                                    ...prodForm.key,
                                  ].join('.') + '.'
                                const fieldIsRequired =
                                  field.isConditionalRequired
                                    ? field.isConditionalRequired(values, name)
                                    : !!field.isRequired
                                const valueIsOk =
                                  !!fieldValue || fieldValue === 0
                                const valueIsDisplay =
                                  !field.isHiding ||
                                  (field.isHiding &&
                                    !field.isHiding(values, name))
                                if (
                                  fieldIsRequired &&
                                  !valueIsOk &&
                                  valueIsDisplay
                                ) {
                                  set(
                                    errors,
                                    [
                                      ...path,
                                      form.key.replace(
                                        'orderCustom.',
                                        'orderAdjustment.'
                                      ),
                                      ...prodForm.key,
                                      ...field.key,
                                    ].join('.'),
                                    'This field is required'
                                  )
                                }
                              })
                            )
                          )
                      )
                    }
                  } else {
                    const collectionProduct = get(
                      values,
                      `orderProducts.${i}.orderCollection`,
                      []
                    )

                    if (!collectionProduct.product) {
                      set(
                        errors,
                        `orderProducts.${i}.orderCollection.product`,
                        'Select product'
                      )
                    } else {
                      const sizes = get(collectionProduct, 'sizes', [])
                      if (sizes.length > 0 && !collectionProduct.size) {
                        set(
                          errors,
                          `orderProducts.${i}.orderCollection.size`,
                          'Select size'
                        )
                      }
                    }

                    if (
                      !collectionProduct.price &&
                      collectionProduct.price !== 0
                    ) {
                      set(
                        errors,
                        `orderProducts.${i}.orderCollection.price`,
                        'The price is required'
                      )
                    }
                  }
                }
              }
            }

            if (step === 2) {
              if (!values.bodyMeasures?.height) {
                set(errors, 'bodyMeasures.height', 'Required')
              }
              if (!values.bodyMeasures?.weight) {
                set(errors, 'bodyMeasures.weight', 'Required')
              }
              if (!values.bodyMeasures?.shoulder) {
                set(errors, 'bodyMeasures.shoulder', 'Required')
              }
              if (!values.bodyMeasures?.chest) {
                set(errors, 'bodyMeasures.chest', 'Required')
              }
              // if (!values.bodyMeasures?.waist) {
              //   set(errors, 'bodyMeasures.waist', 'Required')
              // }

              if (!values.bodyMeasures?.waistJacket) {
                set(errors, 'bodyMeasures.waistJacket', 'Required')
              }

              if (!values.bodyMeasures?.stomach) {
                set(errors, 'bodyMeasures.stomach', 'Required')
              }
              if (!values.bodyMeasures?.hips) {
                set(errors, 'bodyMeasures.hips', 'Required')
              }
              if (!values.bodyMeasures?.biceps) {
                set(errors, 'bodyMeasures.biceps', 'Required')
              }
              if (!values.bodyMeasures?.forearm) {
                set(errors, 'bodyMeasures.forearm', 'Required')
              }
              if (!values.bodyMeasures?.wrist) {
                set(errors, 'bodyMeasures.wrist', 'Required')
              }
              if (!values.bodyMeasures?.armHole) {
                set(errors, 'bodyMeasures.armHole', 'Required')
              }
              if (!values.bodyMeasures?.thigh) {
                set(errors, 'bodyMeasures.thigh', 'Required')
              }
              if (!values.bodyMeasures?.knee) {
                set(errors, 'bodyMeasures.knee', 'Required')
              }
              if (!values.bodyMeasures?.calf) {
                set(errors, 'bodyMeasures.calf', 'Required')
              }
              if (!values.bodyMeasures?.neck) {
                set(errors, 'bodyMeasures.neck', 'Required')
              }

              if (!values.bodyMeasures?.waistPant) {
                set(errors, 'bodyMeasures.waistPant', 'Required')
              }
              if (!values.bodyMeasures?.sideNeckPoint) {
                set(errors, 'bodyMeasures.sideNeckPoint', 'Required')
              }

              if (!values.foot?.footMeasure && values.foot?.footMeasure !== 0) {
                set(errors, 'foot.footMeasure', 'Required')
              }
              // if (!values.foot?.strongFoot) {
              //   set(errors, 'foot.strongFoot', 'Required')
              // }

              if (!values.bodyMeasures?.ankle) {
                set(errors, 'bodyMeasures.ankle', 'Required')
              }
            }

            if (step === 3) {
              // innerStep
              const path = ['orderProducts', innerStep]
              const currentProduct = values.orderProducts[innerStep]

              if (!currentProduct) return

              if (currentProduct.orderProductType === 'collection') {
                // to do check collection errors
                const collectionType = get(
                  currentProduct,
                  'orderCollection.productType',
                  []
                )

                for (const prodKey of collectionType) {
                  formOptions[prodKey].measuresForms.forEach((form) =>
                    form.form.forEach((prodForm) =>
                      prodForm.sections.forEach((section) =>
                        section.fields.forEach((field) => {
                          const name = [
                            ...path,
                            form.key,
                            ...prodForm.key,
                          ].join('.')
                          const fieldValue = get(
                            values,
                            name + '.' + field.key.join('.'),
                            ''
                          )

                          const fieldIsRequired = field.isConditionalRequired
                            ? field.isConditionalRequired(values, name + '.')
                            : !!field.isRequired

                          if (
                            fieldIsRequired &&
                            !fieldValue &&
                            fieldValue !== 0
                          ) {
                            set(
                              errors,
                              name + '.' + field.key.join('.'),
                              'This field is required'
                            )
                          }
                        })
                      )
                    )
                  )
                }
              } else if (currentProduct.orderProductType === 'adjustment') {
                // formOptions[currentProduct.type].measuresForms.forEach((form) =>
                //   form.form.forEach((prodForm) =>
                //     prodForm.sections.forEach((section) =>
                //       section.fields.forEach((field) => {
                //         const fieldValue = get(
                //           values,
                //           [
                //             ...path,
                //             form.key.replace(
                //               'orderCustom.',
                //               'orderAdjustment.'
                //             ),
                //             ...prodForm.key,
                //             ...field.key,
                //           ].join('.'),
                //           ''
                //         )
                //         if (
                //           field.isRequired &&
                //           !fieldValue &&
                //           fieldValue !== 0
                //         ) {
                //           set(
                //             errors,
                //             [
                //               ...path,
                //               form.key.replace(
                //                 'orderCustom.',
                //                 'orderAdjustment.'
                //               ),
                //               ...prodForm.key,
                //               ...field.key,
                //             ].join('.'),
                //             'This field is required'
                //           )
                //         }
                //       })
                //     )
                //   )
                // )
              } else {
                // Fixed design uses category-specific measure forms (e.g. jean, shirt)
                const resolvedMeasureProductType =
                  currentProduct.orderProductType === 'fixed_design'
                    ? getFixedDesignCategory(currentProduct)
                    : getFromKey(currentProduct)

                get(
                  formOptions,
                  `${resolvedMeasureProductType}.measuresForms`,
                  []
                ).forEach(
                  // formOptions[getFromKey(currentProduct)].measuresForms.forEach(
                  (form) =>
                    form.form.forEach((prodForm) =>
                      prodForm.sections.forEach((section) =>
                        section.fields.forEach((field) => {
                          const name = [
                            ...path,
                            form.key,
                            ...prodForm.key,
                          ].join('.')

                          const fieldValue = get(
                            values,
                            name + '.' + field.key.join('.'),
                            ''
                          )

                          const fieldIsRequired = field.isConditionalRequired
                            ? field.isConditionalRequired(values, name + '.')
                            : !!field.isRequired

                          if (
                            fieldIsRequired &&
                            !fieldValue &&
                            fieldValue !== 0
                          ) {
                            set(
                              errors,
                              name + '.' + field.key.join('.'),
                              'This field is required'
                            )
                          }
                        })
                      )
                    )
                )
              }
            }

            return errors
          }}
          onSubmit={async (values) => {
            let paymentStatus = 'unpaid'

            if (values.balance === 0) {
              paymentStatus = 'paid'
            } else if (values.deposit || values.deposit2) {
              paymentStatus = 'deposit'
            }

            const orderProducts = values.orderProducts.map((prod) =>
              prod.orderProductType === 'collection'
                ? (() => {
                    const { options, optionsTemp, optionsFreeText, sizes, ...rest } = prod.orderCollection ?? {}
                    return {
                      ...prod,
                      orderCollection: {
                        ...rest,
                        size: prod.orderCollection?.size ?? undefined,
                      },
                    }
                  })()
                : prod
            )

            saveUserInfos(values)
            udpateOrder.mutate({ ...values, orderProducts, paymentStatus })
          }}
        >
          {({ values, errors, handleChange, validateForm }) => (
            <Form style={{ padding: 24 }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                {step === 1 && (
                  <Step1
                    values={values}
                    errors={errors}
                    validateForm={validateForm}
                    handleChange={handleChange}
                    handleBack={handleBack}
                    handleNext={handleNext}
                    goToPayment={() => setStep(5)}
                    canDirectPayment={canDirectPayment}
                    setCanDirectPayment={setCanDirectPayment}
                  />
                )}
                {step === 2 && (
                  <Step2
                    values={values}
                    errors={errors}
                    validateForm={validateForm}
                    handleChange={handleChange}
                    handleBack={handleBack}
                    handleNext={handleNext}
                    saveUserInfos={() => saveUserInfos(values)}
                    saveBeforeSwitch={() => saveBeforeSwitch(values)}
                    clientDetails={{
                      af: clientDetails.data,
                      dlook: client3DLDetails.data,
                    }}
                    goToPayment={() => setStep(5)}
                    canDirectPayment={canDirectPayment}
                  />
                )}
                {step === 3 && (
                  <Step3
                    values={values}
                    errors={errors}
                    validateForm={validateForm}
                    innerStep={innerStep}
                    setInnerStep={setInnerStep}
                    afterStep3={afterStep3}
                    setAfterStep3={setAfterStep3}
                    handleChange={handleChange}
                    handleBack={handleBack}
                    handleNext={handleNext}
                    goToPayment={() => setStep(5)}
                    clientOrders={clientOrders}
                    canDirectPayment={canDirectPayment}
                    setCanDirectPayment={setCanDirectPayment}
                  />
                )}
                {step === 4 && (
                  <Step4
                    values={values}
                    errors={errors}
                    // validateForm={validateForm}
                    handleChange={handleChange}
                  />
                )}
                {step === 5 && (
                  <Step5
                    values={values}
                    errors={errors}
                    // validateForm={validateForm}
                    handleChange={handleChange}
                    orderDetails={orderDetails}
                  />
                )}
                {step !== 1 && step !== 2 && step !== 3 && (
                  <Space>
                    <Button
                      disabled={udpateOrder.isLoading}
                      onClick={handleBack}
                      type="secondary"
                    >
                      Previous
                    </Button>
                    {step !== 5 && (
                      <Button
                        disabled={Object.keys(errors).length}
                        onClick={() => {
                          if (step === 4) saveUserInfos(values)
                          handleNext()
                        }}
                        type="primary" /*htmlType="submit"*/
                      >
                        {step === 4 ? 'Payment' : 'Next'}
                      </Button>
                    )}
                    {step === 5 && (
                      <Button
                        loading={udpateOrder.isLoading}
                        disabled={Object.keys(errors).length}
                        // onClick={handleNext}
                        type="primary"
                        htmlType="submit"
                      >
                        Finish order
                      </Button>
                    )}
                  </Space>
                )}
              </Space>
            </Form>
          )}
        </Formik>
      )}
    </div>
  )
}

export default ModifyOrder